import { observer } from "mobx-react";
import { SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import PolicyFeeStore from "../../../../stores/policy-fee-store";
import { TAX_OPTIONS } from "../../../../constants";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";

interface IProps {
    fee: PolicyFeeStore;
    validationGroup: IValidationGroup;
}

const TaxCalculator: React.FC<IProps> = observer(({ fee, validationGroup }) => {

    return (
        <SelectDropdown
            value={TAX_OPTIONS.find(o => o.value === Number(fee.isChargeTax))}
            options={TAX_OPTIONS}
            onChange={(v) => fee.setIsChargeTax(Boolean(v?.value))}
            validationGroup={validationGroup}
            required
            isSearchable={false}
        />
    );
});

export default TaxCalculator;
